
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hB2SF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AttachmentGridView", () => $3750f5d7438feb32$export$5ab37d40c5d5b3c9);
$parcel$export(module.exports, "default", () => $3750f5d7438feb32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $lFKmC = parcelRequire("lFKmC");

var $cEHh7 = parcelRequire("cEHh7");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6M6vE = parcelRequire("6M6vE");

var $7qyDl = parcelRequire("7qyDl");

var $dfJ3P = parcelRequire("dfJ3P");

var $2gCtH = parcelRequire("2gCtH");

var $dPP9r = parcelRequire("dPP9r");

var $hxqfC = parcelRequire("hxqfC");

var $eV94v = parcelRequire("eV94v");

var $iowjP = parcelRequire("iowjP");

var $8wXP2 = parcelRequire("8wXP2");

var $dJq4H = parcelRequire("dJq4H");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $gDpUM = parcelRequire("gDpUM");

var $2HbP2 = parcelRequire("2HbP2");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $gqJ3C = parcelRequire("gqJ3C");

var $8G097 = parcelRequire("8G097");

var $9nnYB = parcelRequire("9nnYB");

var $4xedR = parcelRequire("4xedR");

var $7GvHY = parcelRequire("7GvHY");

var $9Qvrl = parcelRequire("9Qvrl");
const $3750f5d7438feb32$var$AttachmentGridViewInternal = (props)=>{
    const intl = (0, $koVbs.default)();
    const { updateTotalItems: updateTotalItems, gridSize: gridSize, startIndex: startIndex, shouldRefreshOnInitialLoad: shouldRefreshOnInitialLoad } = (0, $7GvHY.useGridContext)();
    const isInitialLoad = (0, $5uXOq.useRef)(true);
    const { isMobile: isMobile, isPreview: isPreview, mediaContext: mediaContext, onScrollToComments: onScrollToComments, onScrollToWorklogs: onScrollToWorklogs, viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const [, { setMaxResults: setMaxResults }] = (0, $gqJ3C.useAttachmentStoreActions)();
    const [{ value: { attachments: attachments = [], totalCount: totalCount }, error: error }, { refreshAttachments: refreshAttachments }] = (0, $7qyDl.useIssueAttachments)(issueKey, {
        maxResults: gridSize
    });
    const canDeleteAttachmentMapModal = (0, $6M6vE.useCanDeleteAttachment)();
    const items = (0, $5uXOq.useMemo)(()=>attachments.map((attachment)=>{
            const identifier = {
                mediaItemType: 'file',
                id: attachment.mediaApiFileId,
                attachmentId: attachment.id,
                ...mediaContext.viewContext && mediaContext.viewContext.collection !== null ? {
                    collectionName: mediaContext.viewContext.collection
                } : {}
            };
            const actions = (0, $8G097.getActionsForAttachment)(attachment.id, attachment.parentName, attachment.parentId, canDeleteAttachmentMapModal[attachment.id], intl, issueKey, onScrollToComments, onScrollToWorklogs);
            return {
                filename: attachment.filename,
                identifier: identifier,
                createdDate: attachment.createdDate ? attachment.createdDate * 1000 : 0,
                mimetype: attachment.mimetype,
                selectable: false,
                actions: actions,
                isLazy: !isMobile,
                isPreview: isPreview,
                hasRestrictedParent: attachment.hasRestrictedParent
            };
        }), [
        attachments,
        intl,
        isMobile,
        issueKey,
        mediaContext.viewContext,
        onScrollToComments,
        onScrollToWorklogs,
        canDeleteAttachmentMapModal,
        isPreview
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRefreshAttachments = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(refreshAttachments, (0, $9Qvrl.DEBOUNCE_DURATION)), [
        refreshAttachments
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        refreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        refreshAttachments,
        startIndex,
        gridSize
    ]);
    // Refresh attachments when there is a changes ingrid size of page number
    (0, $5uXOq.useEffect)(()=>{
        // On initial load, only refresh if totalCount or gridSize is more than 12
        if (isInitialLoad.current) {
            if (shouldRefreshOnInitialLoad) debouncedRefreshAttachments(issueKey, {
                startAt: startIndex,
                maxResults: gridSize
            });
            isInitialLoad.current = false;
            return;
        }
        // After initial load, refresh on gridSize or startIndex changes
        debouncedRefreshAttachments(issueKey, {
            startAt: startIndex,
            maxResults: gridSize
        });
    }, [
        issueKey,
        debouncedRefreshAttachments,
        startIndex,
        gridSize,
        shouldRefreshOnInitialLoad
    ]);
    // Update store's maxResults when grid size changes
    (0, $5uXOq.useEffect)(()=>{
        setMaxResults(gridSize);
    }, [
        setMaxResults,
        gridSize
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateTotalItems(totalCount);
    }, [
        updateTotalItems,
        totalCount
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dfJ3P.default), {
        shouldHideImage: true,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nnYB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xedR.default), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        shouldEnableDownloadButton: shouldEnableDownloadButton,
        totalCount: totalCount
    })));
};
const $3750f5d7438feb32$export$5ab37d40c5d5b3c9 = (props)=>{
    const { viewMediaClientConfig: viewMediaClientConfig } = props;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const shouldEnableDownloadButton = (0, $17Gip.useCanDownloadAttachments)(projectKey);
    const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
            ...viewMediaClientConfig,
            enforceDataSecurityPolicy: (0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') && !shouldEnableDownloadButton
        }), [
        shouldEnableDownloadButton,
        viewMediaClientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
            clientConfig: mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3750f5d7438feb32$var$AttachmentGridViewInternal, {
            ...props,
            viewMediaClientConfig: mediaClientConfig
        })));
};
const $3750f5d7438feb32$var$AttachmentGridViewConnect = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $dPP9r.default), (0, $hxqfC.connect)((state)=>({
        mediaContext: (0, $gDpUM.mediaContextSelector)(state),
        isMobile: (0, $a1ky2.isMobileSelector)(state),
        isPreview: (0, $bcoYn.isPreviewSelector)(state)
    }), (dispatch)=>({
        onCardCoverShow: (currentAttachmentId, newAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId, newAttachmentId));
        },
        onCardCoverHide: (currentAttachmentId)=>{
            dispatch((0, $eV94v.cardCoverUpdateRequest)(currentAttachmentId));
        },
        onScrollToComments: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentComment)());
        },
        onScrollToWorklogs: ()=>{
            dispatch((0, $iowjP.scrollToAttachmentWorklog)());
        },
        onViewRefresh: ()=>{
            dispatch((0, $dJq4H.fetchViewContextRequest)());
        },
        onUploadRefresh: ()=>{
            dispatch((0, $8wXP2.fetchUploadContextRequest)());
        }
    })))($3750f5d7438feb32$export$5ab37d40c5d5b3c9);
var $3750f5d7438feb32$export$2e2bcd8739ae039 = $3750f5d7438feb32$var$AttachmentGridViewConnect;

});
parcelRegister("4xedR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4694b1189a6fa987$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nXXc = parcelRequire("7nXXc");
const $4694b1189a6fa987$var$GridItems = ({ items: items, mediaClientConfig: mediaClientConfig, shouldEnableDownloadButton: shouldEnableDownloadButton, totalCount: totalCount })=>{
    const attachmentIdentifiers = items.map((item)=>item.identifier);
    return items.map((item)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nXXc.default), {
            item: item,
            key: item.identifier.id,
            attachmentIdentifiers: attachmentIdentifiers,
            mediaClientConfig: mediaClientConfig,
            shouldEnableDownloadButton: shouldEnableDownloadButton,
            totalCount: totalCount
        });
    });
};
var $4694b1189a6fa987$export$2e2bcd8739ae039 = $4694b1189a6fa987$var$GridItems;

});
parcelRegister("7nXXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $814f9f21f0d6acb8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $8Ppwv = parcelRequire("8Ppwv");

var $3bDjY = parcelRequire("3bDjY");

var $4lTz8 = parcelRequire("4lTz8");

var $4R6GH = parcelRequire("4R6GH");

var $4h3hM = parcelRequire("4h3hM");

var $9Qvrl = parcelRequire("9Qvrl");

var $79OHK = parcelRequire("79OHK");

var $kZXZE = parcelRequire("kZXZE");

var $9dwUH = parcelRequire("9dwUH");
const { height: $814f9f21f0d6acb8$var$height, infoSectionHeight: $814f9f21f0d6acb8$var$infoSectionHeight } = (0, $9Qvrl.GRID_ITEM_DIMENSIONS);
const $814f9f21f0d6acb8$var$cardDimensions = {
    width: '100%',
    height: $814f9f21f0d6acb8$var$height - $814f9f21f0d6acb8$var$infoSectionHeight
};
const $814f9f21f0d6acb8$var$placeholderText = ' ';
const $814f9f21f0d6acb8$var$MediaCardItem = ({ item: item, mediaClientConfig: mediaClientConfig, shouldEnableDownloadButton: shouldEnableDownloadButton, attachmentIdentifiers: attachmentIdentifiers, totalCount: totalCount })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        key: item.identifier.id,
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.media-card-item",
        "aria-label": item.filename,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1reo15vq _18m915vq _19itzgxb _v564z97a _vchhusvi _1ul9s0ka _1bsb1osq _4t3i1j4a _80omtlke _bfhkk3f8 _1cwgv77o _12y31bk5 _vsjokb7n _1rrqkb7n _sfou1ule _1nuj1ule _pbhanqa1 _1guj1p6i"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        tag: "span",
        content: item.filename
    }, /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), null, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $8Ppwv.default), {
        mediaClientConfig: mediaClientConfig,
        mediaViewerItems: attachmentIdentifiers,
        useInlinePlayer: false,
        shouldOpenMediaViewer: true,
        dimensions: $814f9f21f0d6acb8$var$cardDimensions,
        featureFlags: (0, $4h3hM.mediaFeatureFlags)(),
        disableOverlay: true,
        shouldEnableDownloadButton: !(0, $4R6GH.fg)('block_attachment_download_on_data_export_dsp_rule') || shouldEnableDownloadButton,
        ...item,
        testId: `issue.views.issue-base.content.attachment.grid-view.attachment-id.${item.identifier.attachmentId}`
    }), /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_v564ybtr _kqswstnw _1bsb1osq _4t3i1osq _c71l1osq _p12f1osq _1ltvidpf _154iidpf _bfhk10xm _1pbykb7n _lcxvglyw _1e0cglyw",
            "media-card-blanket"
        ])
    }), /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_v564m7ou _kqswstnw _154iidpf _1xi2idpf _1pbykb7n _tzy4idpf",
            "media-card-actions"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $9dwUH.default), {
        item: item,
        totalCount: totalCount
    }))), /*#__PURE__*/ $5uXOq.createElement((0, $kZXZE.TitleBoxWrapper), null, /*#__PURE__*/ $5uXOq.createElement((0, $kZXZE.TitleBoxHeader), null, /*#__PURE__*/ $5uXOq.createElement((0, $4lTz8.Truncate), {
        text: item.filename || '',
        startFixedChars: 3,
        endFixedChars: 7
    })), /*#__PURE__*/ $5uXOq.createElement((0, $kZXZE.TitleBoxFooter), null, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), null, item.createdDate ? /*#__PURE__*/ $5uXOq.createElement((0, $79OHK.DateFormatter), {
        timestamp: item.createdDate
    }) : $814f9f21f0d6acb8$var$placeholderText))))));
};
var $814f9f21f0d6acb8$export$2e2bcd8739ae039 = $814f9f21f0d6acb8$var$MediaCardItem;
const $814f9f21f0d6acb8$var$mediaCardStyle = null;
const $814f9f21f0d6acb8$var$actionsContainerStyle = null;
const $814f9f21f0d6acb8$var$mediaCardContainerStyle = null;
const $814f9f21f0d6acb8$var$blanketStyle = null;

});
parcelRegister("79OHK", function(module, exports) {

$parcel$export(module.exports, "DateFormatter", () => $c1c3101b2ed64590$export$ad991b66133851cf);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $2tElP = parcelRequire("2tElP");
var $koVbs = parcelRequire("koVbs");

var $hrSvI = parcelRequire("hrSvI");
const $c1c3101b2ed64590$export$7d2ccdaffce6e3f = 1;
const $c1c3101b2ed64590$export$6879ea1c217f4705 = $c1c3101b2ed64590$export$7d2ccdaffce6e3f * 1000;
const $c1c3101b2ed64590$export$f4aba04677f37907 = $c1c3101b2ed64590$export$6879ea1c217f4705 * 60;
const $c1c3101b2ed64590$export$1bf939ebcf31ef0e = $c1c3101b2ed64590$export$f4aba04677f37907 * 60;
const $c1c3101b2ed64590$export$1a58b8d7f494dd72 = $c1c3101b2ed64590$export$1bf939ebcf31ef0e * 24;
const $c1c3101b2ed64590$export$3241045aa1844a20 = $c1c3101b2ed64590$export$1a58b8d7f494dd72 * 7;
const $c1c3101b2ed64590$export$fa5253a4540f3e3a = $c1c3101b2ed64590$export$1a58b8d7f494dd72 * 30;
const $c1c3101b2ed64590$export$90b88dc425a06a95 = $c1c3101b2ed64590$export$1a58b8d7f494dd72 * 365;
const $c1c3101b2ed64590$var$WithUpdatedLabel = (formattedDate)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...formattedDate ? (0, $hrSvI.messages).overOneMinuteText : (0, $hrSvI.messages).underOneMinuteText,
        values: {
            date: formattedDate
        }
    });
function $c1c3101b2ed64590$export$75477e21c4edfb09(dateNum, locale = 'en-US') {
    const date = new Date(Number(dateNum));
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString(locale, {
        month: 'short'
    });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
}
const $c1c3101b2ed64590$export$ad991b66133851cf = ({ timestamp: timestamp })=>{
    const locale = (0, $koVbs.default)().locale;
    const calculateTimeDiff = (0, $5uXOq.useCallback)(()=>Math.floor(Number(timestamp) - Date.now()), [
        timestamp
    ]);
    const getTimeUnit = ()=>{
        const millisecondsSinceUpdate = calculateTimeDiff();
        const absMilliseconds = Math.abs(millisecondsSinceUpdate);
        if (absMilliseconds < $c1c3101b2ed64590$export$f4aba04677f37907) return {
            value: 0,
            unit: 'second'
        };
        if (absMilliseconds < $c1c3101b2ed64590$export$1bf939ebcf31ef0e) return {
            value: Math.floor(millisecondsSinceUpdate / $c1c3101b2ed64590$export$f4aba04677f37907),
            unit: 'minute'
        };
        if (absMilliseconds < $c1c3101b2ed64590$export$1a58b8d7f494dd72) return {
            value: Math.floor(millisecondsSinceUpdate / $c1c3101b2ed64590$export$1bf939ebcf31ef0e),
            unit: 'hour'
        };
        if (absMilliseconds < $c1c3101b2ed64590$export$3241045aa1844a20) return {
            value: Math.floor(millisecondsSinceUpdate / $c1c3101b2ed64590$export$1a58b8d7f494dd72),
            unit: 'day'
        };
        if (absMilliseconds < 2 * $c1c3101b2ed64590$export$3241045aa1844a20) return {
            value: Math.floor(millisecondsSinceUpdate / $c1c3101b2ed64590$export$3241045aa1844a20),
            unit: 'week'
        };
        return null;
    };
    const timeUnit = getTimeUnit();
    if (timeUnit?.value === 0 && timeUnit.unit === 'second') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hrSvI.messages).underOneMinuteText);
    if (!timeUnit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, $c1c3101b2ed64590$export$75477e21c4edfb09(timestamp, locale));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tElP.default), {
        value: timeUnit.value,
        unit: timeUnit.unit
    }, $c1c3101b2ed64590$var$WithUpdatedLabel);
};

});
parcelRegister("hrSvI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef80fde02f69dc28$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ef80fde02f69dc28$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    underOneMinuteText: {
        "id": "autodev.common.time-elapsed.under-one-minute-text",
        "defaultMessage": "Just now"
    },
    overOneMinuteText: {
        "id": "autodev.common.time-elapsed.over-one-minute-text",
        "defaultMessage": "{date}"
    },
    download: {
        "id": "issue.views.issue-base.content.attachment.grid-view.download",
        "defaultMessage": "Download"
    },
    delete: {
        "id": "issue.views.issue-base.content.attachment.grid-view.delete",
        "defaultMessage": "Delete"
    }
});

});


parcelRegister("kZXZE", function(module, exports) {

$parcel$export(module.exports, "TitleBoxWrapper", () => $da83134f0f1ae752$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $da83134f0f1ae752$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $da83134f0f1ae752$export$1004da4fc5583975);
/* TitleBox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $da83134f0f1ae752$var$titleBoxWrapperStyles = null;
const $da83134f0f1ae752$export$213c428ce4ec143c = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxWrapper",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box",
        className: (0, $bwpsq.default)([
            "_11c81o8v _bfhkvuon _80om1kw7 _lcxvglyw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
        ])
    }, children);
};
const $da83134f0f1ae752$var$infoStyles = null;
const $da83134f0f1ae752$export$43970d913b015380 = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxHeader",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-header",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c"
        ])
    }, children);
};
const $da83134f0f1ae752$var$titleBoxFooterStyle = null;
const $da83134f0f1ae752$export$1004da4fc5583975 = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: "titleBoxFooter",
        "data-testid": "issue-view-base.content.attachment.grid-view.ui.components.media-card.title-box-footer",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c",
            "_4t3if6fq _1e0c1txw _1bah1yb4 _4cvr1h6o _syaz131l"
        ])
    }, children);
};
const $da83134f0f1ae752$var$TitleBox = {
    Wrapper: $da83134f0f1ae752$export$213c428ce4ec143c,
    Header: $da83134f0f1ae752$export$43970d913b015380,
    Footer: $da83134f0f1ae752$export$1004da4fc5583975
};
var $da83134f0f1ae752$export$2e2bcd8739ae039 = $da83134f0f1ae752$var$TitleBox;

});

parcelRegister("9dwUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5390dc1ab27b62f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");
var $krXdA = parcelRequire("krXdA");

var $d4dv2 = parcelRequire("d4dv2");

var $hUqzg = parcelRequire("hUqzg");

var $24tOd = parcelRequire("24tOd");
var $dTQMj = parcelRequire("dTQMj");

var $1k7cJ = parcelRequire("1k7cJ");

var $koVbs = parcelRequire("koVbs");

var $6M6vE = parcelRequire("6M6vE");


var $k4y2N = parcelRequire("k4y2N");

var $3Khee = parcelRequire("3Khee");

var $2KAtx = parcelRequire("2KAtx");

var $jcw0u = parcelRequire("jcw0u");

var $hrSvI = parcelRequire("hrSvI");
const $5390dc1ab27b62f6$var$DeleteButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ buttonProps: buttonProps, onClick: onClick }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $5390dc1ab27b62f6$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...buttonProps,
        ref: ref,
        onClick: onClick
    })));
const $5390dc1ab27b62f6$var$MediaCardActions = ({ item: item, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fileState: fileState } = (0, $24tOd.useFileState)(item.identifier.id);
    const [isAbuseModalOpen, setIsAbuseModalOpen] = (0, $5uXOq.useState)(false);
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const canDeleteAttachmentMap = (0, $6M6vE.useCanDeleteAttachment)();
    const isAttachmentLimitReached = (0, $3Khee.isAttachmentNumberApproachLimit)(totalCount);
    const canDelete = canDeleteAttachmentMap[item.identifier.attachmentId];
    const downloadFn = (0, $5uXOq.useCallback)(async (event)=>{
        event?.stopPropagation();
        event?.preventDefault();
        try {
            await mediaClient.file.downloadBinary(item.identifier.id);
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)({
                meta: {
                    id: 'jira.issue.attachments.downloadBinary',
                    packageName: 'jira.issue.attachments'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        setIsAbuseModalOpen(false);
    }, [
        item.identifier.id,
        mediaClient.file
    ]);
    const handleDownload = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (fileState?.status !== 'error' && fileState?.abuseClassification) setIsAbuseModalOpen(true);
        else downloadFn();
    }, [
        downloadFn,
        fileState
    ]);
    const handleCloseAbuseModal = (0, $5uXOq.useCallback)((event)=>{
        event?.stopPropagation();
        event?.preventDefault();
        setIsAbuseModalOpen(false);
    }, []);
    const deleteEntryPointProps = (0, $5uXOq.useMemo)(()=>({
            attachmentView: (0, $6fcd443f11817883$export$fe95a8f0244a32c4),
            deletingAttachmentId: item.identifier.attachmentId
        }), [
        item.identifier.attachmentId
    ]);
    const deleteModalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'small'
        }), []);
    const downloadButtonCommonProps = {
        testId: `issue.views.issue-base.content.attachment.grid-view.download.${item.identifier.attachmentId}`,
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))),
        label: formatMessage((0, $hrSvI.messages).download)
    };
    const deleteButtonCommonProps = {
        testId: `issue.views.issue-base.content.attachment.grid-view.delete.${item.identifier.attachmentId}`,
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hUqzg))),
        label: formatMessage((0, $hrSvI.messages).delete)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isAbuseModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1k7cJ.AbuseModal), {
        isOpen: isAbuseModalOpen,
        onConfirm: downloadFn,
        onClose: handleCloseAbuseModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5390dc1ab27b62f6$var$actionsStyle,
        testId: "issue-view-base.content.attachment.grid-view.ui.components.media-card.media-card-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050"
    }, isAttachmentLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $5390dc1ab27b62f6$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...downloadButtonCommonProps,
        href: `/rest/api/3/attachment/content/${item.identifier.attachmentId}`,
        onClick: (event)=>event.stopPropagation()
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $5390dc1ab27b62f6$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...downloadButtonCommonProps,
        onClick: handleDownload
    })), canDelete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $k4y2N.issueAttachmentsDeleteModalEntrypoint),
        entryPointProps: deleteEntryPointProps,
        modalProps: deleteModalProps,
        useInternalModal: true,
        interactionName: "issue-attachment-grid-view-delete-attachment"
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5390dc1ab27b62f6$var$DeleteButton, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            buttonProps: deleteButtonCommonProps,
            onClick: (event)=>event.stopPropagation()
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $5390dc1ab27b62f6$var$buttonStyle
    }, item.actions[0]?.icon))));
};
const $5390dc1ab27b62f6$var$actionsStyle = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: "var(--ds-space-050, 4px)",
    right: "var(--ds-space-050, 4px)",
    zIndex: '1',
    transition: 'opacity 0.2s ease-in-out'
});
const $5390dc1ab27b62f6$var$buttonStyle = (0, $8CUq3.xcss)({
    transition: 'background-color 0.2s',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    backgroundColor: 'elevation.surface.overlay',
    minWidth: '32px',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':focus-within': {
        backgroundColor: 'elevation.surface.overlay.hovered',
        outlineWidth: "var(--ds-border-width-outline, 2px)",
        outlineStyle: 'solid',
        outlineOffset: 'space.025',
        outlineColor: 'color.border.focused'
    }
});
var $5390dc1ab27b62f6$export$2e2bcd8739ae039 = $5390dc1ab27b62f6$var$MediaCardActions;

});
const $6fcd443f11817883$export$2671699244327210 = 'filmStripView';
const $6fcd443f11817883$export$fe95a8f0244a32c4 = 'listView';
const $6fcd443f11817883$export$6355e0dd8d72dab = 'gridView';






//# sourceMappingURL=async-attachment-grid-view.ed69e880.js.map
